import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import firebase from 'firebase/compat/app';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChevronDown, faBars } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import "../CSS/Header.css";
import Icon from "../Images/janushreeLogo.png";

const Header1 = () => {
  const location = useLocation(); // Get the current location
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false); // State to manage the mobile menu visibility

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    });
    return unsubscribe;
  }, []);

  const handleLogout = () => {
    firebase.auth().signOut().then(() => {
      setIsLoggedIn(false);
      navigate("/");
    });
  };

  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getServicesTitle");
        setServices(response.data);
        console.log("Fetched Services:", response.data); 
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getCoursesTitle");
        setCourses(response.data);
        console.log("Fetched Courses:", response.data); 
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible); // Toggle the mobile menu visibility
  };

  return (
    <nav className="navbar navbar-expand-lg ftco_navbar ftco-navbar-light demo-header" id="ftco-navbar">
      <div className="container">
        <a className="navbar-brand" href="/" style={{ color: "#c11c84" }}>
          JanuShree Ladies<br />
          <span style={{ marginLeft: "80px", fontSize: "18px" }}>Parlour</span>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu} // Toggle the menu when clicked
          aria-controls="ftco-nav"
          aria-expanded={menuVisible ? 'true' : 'false'}
          aria-label="Toggle navigation"
          style={{color: "black"}}
        >
          <FontAwesomeIcon icon={faBars} /> {/* Hamburger icon */}
        </button>
        <div className={`collapse navbar-collapse ${menuVisible ? 'show' : ''}`} id="ftco-nav">
          <ul className="navbar-nav ml-auto">
            <li className={`nav-item  ${location.pathname === '/' ? 'active' : ''}`}>
              <Link to="/" className="nav-link text-white">
                Home
              </Link>
            </li>
            <li className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}>
              <Link to="/about" className="nav-link text-white">
                About
              </Link>
            </li>
            <li className={`nav-item ${location.pathname === '/service' ? 'active' : ''}`}>
              <Link to="/service" className="nav-link text-white">
                Services
              </Link>
            </li>
            <li className="nav-item dropdown position-relative">
              <a href="#" className="nav-link dropdown-toggle text-white" data-toggle="dropdown" aria-expanded="false">
                Work
              </a>
              <ul className="dropdown-menu">
                {services.map((service) => (
                  <li key={service.service_id}>
                    <Link to={`/services${service.route}`} className="dropdown-item">
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li className={`nav-item dropdown position-relative`}>
            <a href="#" className="nav-link dropdown-toggle text-white" data-toggle="dropdown" aria-expanded="false">
                Courses
              </a>
              <ul className="dropdown-menu">
                {courses.map((course) => (
                  <li key={course.service_id}>
                    <Link to={`/courses${course.route}`} className="dropdown-item">
                      {course.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li className={`nav-item ${location.pathname === '/gallery' ? 'active' : ''}`}>
              <Link to="/gallery" className="nav-link text-white">
                Gallery
              </Link>
            </li>
            <li className={`nav-item ${location.pathname === '/contact' ? 'active' : ''}`}>
              <Link to="/contact" className="nav-link text-white">
                Contact
              </Link>
            </li>
          </ul>
          <div className="user-menu">
            <div className="dropdown">
              <FontAwesomeIcon icon={faUser} className="user-icon text-white" />
              <div className="dropdown-content">
                {isLoggedIn ? (
                  <>
                    <a href="/workedit">Work</a>
                    <a href="/galleryedit">Gallery</a>
                    <a href="/offeredit">Offer</a>
                    <a href="/serviceedit">Service</a>
                    <a href="/courseedit">Course</a>
                    <a href="/profile">Profile</a>
                    <a href="/seo">SEO</a>
                    <a href="/sociallinks">Social Links</a>
                    <a href="#" onClick={handleLogout}>Logout</a>
                  </>
                ) : (
                  <Link to="/auth" className="nav-link">Login</Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header1;
